import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { Upload } from "../utils/local-antd";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Spacing } from "../theme/Spacing";
import type { UploadFile, UploadProps } from "../utils/local-antd";
import { Button } from "./Button";

const { Dragger } = Upload;

const StyledButton = styled(Button)`
  margin: 0;
  padding: ${Spacing.xxxl};
  background-color: transparent;
  color: ${({ theme }) => theme.darkerSub};
`;

const StyledDragger = styled(Dragger)`
  .ant-upload {
    width: 100% !important;
    display: block;
    padding: 0 !important;
  }

  .ant-btn-variant-outlined {
    background-color: ${({ theme }) => theme.darkSub} !important;
    width: 100%;
    height: 7rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${Spacing.m};
    border: 0;
  }

  .ant-upload-drag {
    overflow: hidden !important;
    border-color: ${({ theme }) => theme.black} !important;
  }

  .ant-upload-drag-hover,
  .ant-upload-drag-hover:hover,
  .ant-upload-drag:not(.ant-upload-disabled):hover {
    border-color: ${({ theme }) => theme.darkerSub} !important;
  }

  .ant-btn-variant-outlined:hover,
  .ant-upload-drag-hover .ant-btn-variant-outlined {
    color: ${({ theme }) => theme.darkerSub} !important;
  }
`;

const uploadPropsConfig: UploadProps = {
  name: "file",
  defaultFileList: [],
  beforeUpload: (file) => false,
};

type LocalUplaodProps = {
  onChange: (file: UploadFile) => void;
  defaultFiles?: UploadFile[];
  className?: string;
  title?: string;
  dragHover?: boolean;
} & Omit<UploadProps, "onChange">;

export const AtiraUpload: React.FC<LocalUplaodProps> = (props) => {
  const { t } = useTranslation();

  if (props.dragHover) {
    return (
      <StyledDragger
        className={props.className}
        {...uploadPropsConfig}
        maxCount={1}
        defaultFileList={props.defaultFiles}
        onChange={(info) => {
          if (info.file.status !== "removed") {
            props.onChange(info.file);
          }
        }}
        accept={props.accept}
      >
        <StyledButton icon={faFileUpload}>
          {props.title || t("common.upload_file")}
        </StyledButton>
      </StyledDragger>
    );
  }

  return (
    <Upload
      className={props.className}
      {...uploadPropsConfig}
      maxCount={1}
      defaultFileList={props.defaultFiles}
      onChange={(info) => {
        if (info.file.status !== "removed") {
          props.onChange(info.file);
        }
      }}
      accept={props.accept}
    >
      <StyledButton icon={faFileUpload}>
        {props.title || t("common.upload_file")}
      </StyledButton>
    </Upload>
  );
};
